import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import { getLearningAsset, getManyLearningAssets, putLearningAsset } from '../../../../shared/actions/LearningAssets';
import { LEARNING_ASSET_TYPES } from '../../../../shared/Constants';
import { makeGetObjectsFromStateById } from '../../../../shared/selectors/index';
import CopySectionForm from './CopySectionForm';

class CopySection extends Component {
    static propTypes = {
        getManyLearningAssets: PropTypes.func,
        putLearningAsset: PropTypes.func,
        getLearningAsset: PropTypes.func,
        learningAssets: PropTypes.array,
        assetsById: PropTypes.object,
        history: PropTypes.object
    };

    static contextType = RuntimeContext;

    componentDidMount() {
        this.props.getManyLearningAssets({ pathsContext: this.context.pathsWeb });
    }

    onSubmit = (asset) => this.props.putLearningAsset({ learningAssetId: asset._id, body: asset });

    onLearningAssetSelect = (learningAssetId) =>
        this.props.getLearningAsset({ learningAssetId, pathsContext: this.context.pathsWeb });

    onCancel = () => {
        this.props.history.push('/managelearningassets');
    };

    render() {
        const { learningAssets, assetsById } = this.props;
        return (
            <div className={'container'}>
                <CopySectionForm
                    onLearningAssetSelect={this.onLearningAssetSelect}
                    onCancel={this.onCancel}
                    onSubmit={this.onSubmit}
                    assetsById={assetsById}
                    learningAssets={learningAssets}
                />
            </div>
        );
    }
}
export const CopySectionComponent = CopySection;

export const makeMapStateToProps = () => {
    const getObjectsFromState = makeGetObjectsFromStateById('learningAssets');
    const mapStateToProps = (state) => {
        const {
            learningAssets: { byId }
        } = state;
        const availableTypes = {
            [LEARNING_ASSET_TYPES.TRACK]: true,
            [LEARNING_ASSET_TYPES.IMPACT_PROJECT]: true,
        };
        const availableAssets = getObjectsFromState(state).filter((asset) => availableTypes[asset.type]);
        return {
            learningAssets: availableAssets,
            assetsById: byId
        };
    };
    return mapStateToProps;
};

export const mapDispatchToProps = (dispatch) => ({
    getManyLearningAssets: (params) => dispatch(getManyLearningAssets(params)),
    putLearningAsset: (params) => dispatch(putLearningAsset(params)),
    getLearningAsset: (params) => dispatch(getLearningAsset(params))
});

export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(CopySection));
